import { useContext, useEffect, useRef } from 'react';
import { NavContext, Title } from '@bpm-web-app/components';
import { ArtistApplication } from '@bpm-web-app/components/pages';
import { ArtistPortalHeaderContext } from '@bpm-web-app/components/src/lib/supreme-header/artist-portal-header.context';
import { useRouter } from 'next/router';
import { useArtistProfileStatus } from '@bpm-web-app/utils';
import { ArtistApplicationStatus } from '@bpm-web-app/download-api-sdk';

export default function Index({ title }: { title: string }) {
    const { hideNav, showNav } = useContext(NavContext);
    const { hideSubmitTrackButton, resetSubmitTrackButton } = useContext(ArtistPortalHeaderContext);
    const { application_status: applicationStatus } = useArtistProfileStatus();
    const didNavigte = useRef(false);
    const router = useRouter();

    useEffect(() => {
        hideNav();
        hideSubmitTrackButton();
        return function cleanup() {
            showNav();
            resetSubmitTrackButton();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (window.fbq) {
            window?.fbq('track', 'Lead');
        }
    }, []);

    useEffect(() => {
        if (didNavigte.current) {
            return;
        }
        didNavigte.current = true;
        if ([ArtistApplicationStatus.Pending, ArtistApplicationStatus.Approved].includes(applicationStatus)) {
            router.replace('/');
        }
    }, [applicationStatus, router]);

    return (
        <>
            <Title title={title} platform="artist" />
            <ArtistApplication />
        </>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'Artist Application'
        }
    };
}
